export const alphanumeric = /^[A-Za-z0-9 ]+$/
